import { useSelector } from "react-redux";

import { useCustomerFaqs } from "js/placeholderData/authed-customer-faqs";
import { useUnauthCustomerFaqs } from "js/placeholderData/unauth-customer-faqs";

export default function useCustomerTopThreeFAQs() {
  const { user } = useSelector((s) => s.user);
  const unauthCustomerFaqs = useUnauthCustomerFaqs();
  const customerFaqs = useCustomerFaqs();

  if (!user?.userId) return unauthCustomerFaqs.slice(0, 3);

  return customerFaqs.slice(0, 3);
}
